import {
    get,
    post,
    put,
    Delete,
    formDataPost,
    postWithQuery,
    putWithQuery,
} from "../ApiDecorator";

/**
 * 阅卷管理 · 考试任务（/course/spx/examTask）
 */
const ExamTask = {
    /** GET 年级 / 班级选项 */
    getOptions(data) {
        return get("/course/spx/examTask/options", data);
    },
    /** GET 负责人候选（空间成员） */
    getOwnerList(data) {
        return get("/course/spx/examTask/owner/list", data);
    },
    /** GET 按空间和学科查询关联试卷 */
    getPaperList(data) {
        return get("/course/spx/examTask/paper/list", data);
    },
    /** POST 保存考试任务（无 id 新建，有 id 修改） */
    save(data) {
        return post("/course/spx/examTask", data);
    },
    /** POST 导入考生 Excel */
    importStudents(data) {
        return formDataPost("/course/spx/examTask/student/import", data);
    },
    /** POST 导入学生答题卡（OSS 直传后提交 fileName + ossUrl；async=true 时后台拆分，进度看列表 importing） */
    importStudentSheets(data) {
        return post("/course/spx/examTask/studentSheet/import", data);
    },
    /** GET 空间任务列表（query: projectId、spxId 必填） */
    getList(data) {
        return get("/course/spx/examTask/list", data);
    },
    /** GET 当前项目下全部空间的任务列表（query: projectId 必填，由前端传入） */
    getProjectList(data) {
        return get("/course/spx/examTask/project/list", data);
    },
    /** GET 任务统计（按空间） */
    getSummary(data) {
        return get("/course/spx/examTask/summary", data);
    },
    /** GET 任务详情 */
    getDetail(data) {
        return get("/course/spx/examTask/detail", data);
    },
    /** DELETE 删除任务 */
    delete(data) {
        return Delete("/course/spx/examTask", data);
    },
    /** PUT 发布任务（query: id） */
    publish(data) {
        return putWithQuery("/course/spx/examTask/publish", {}, data);
    },
    /** PUT 取消发布（query: id） */
    unpublish(data) {
        return putWithQuery("/course/spx/examTask/unpublish", {}, data);
    },
    /** GET 考生列表 */
    getStudentList(data) {
        return get("/course/spx/examTask/student/list", data);
    },
    /** GET 学生答题卡列表（任务级 importing / recognizing，单条 recognizeStatus、pageStatus） */
    getStudentSheetList(data) {
        return get("/course/spx/examTask/studentSheet/list", data);
    },
    /** PUT 确认答题卡匹配 */
    confirmStudentSheet(data) {
        return put("/course/spx/examTask/studentSheet/confirm", data);
    },
    /** POST 重新识别答题卡 */
    retryStudentSheet(data) {
        return postWithQuery("/course/spx/examTask/studentSheet/retry", {}, data);
    },
    /** GET 项目学生管理列表（query: projectId 必填） */
    getProjectStudentList(data) {
        return get("/course/spx/examTask/project/student/list", data);
    },
    /** GET 项目学生成绩（query: projectId、studentNo 必填） */
    getProjectStudentScore(data) {
        return get("/course/spx/examTask/project/student/score", data);
    },
    /** GET 项目试卷管理列表（query: projectId 必填） */
    getProjectPaperList(data) {
        return get("/course/spx/examTask/project/paper/list", data);
    },
    /** GET 试卷作答学生（query: projectId、paperId 必填） */
    getProjectPaperStudentList(data) {
        return get("/course/spx/examTask/project/paper/student/list", data);
    },
};

export default ExamTask;
